import type { SSEEventPayload, SSEEventType } from "@egalregal/shared";

/**
 * Global SSE event bus backed by EventTarget.
 * The connection singleton dispatches here; components subscribe via useSSEEvent.
 */

export type SSEPayload = SSEEventPayload;

const bus = new EventTarget();

/** Dispatch an SSE event into the global bus. */
export function dispatchSSEEvent(type: SSEEventType, data: SSEPayload): void {
  bus.dispatchEvent(new CustomEvent(type, { detail: data }));
}

/** Subscribe to an SSE event type. Returns an unsubscribe function. */
export function subscribeSSE(
  type: SSEEventType,
  handler: (data: SSEPayload) => void,
): () => void {
  const listener = (e: Event) => handler((e as CustomEvent).detail);
  bus.addEventListener(type, listener);
  return () => bus.removeEventListener(type, listener);
}
